module.exports = __webpack_public_path__ + "img/tabbar2-1.1f0c7ab2.svg";